
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"0 0 60 47","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M54.244 14.492L30.69.15c-.34-.2-.752-.2-1.092 0L5.511 14.672c-.32.19-.511.54-.511.912 0 .37.2.71.52.9l7.813 4.588v7.37c0 .371.19.712.51.902L29.607 38.9c.34.2.761.2 1.092 0l10.105-6.16v9.224l-2.744 2.744c-.41.41-.41 1.082 0 1.492.41.411 1.081.411 1.492 0l2.313-2.313L44.18 46.2c.41.411 1.082.411 1.492 0 .41-.41.41-1.081 0-1.492l-2.744-2.744V31.457l4.076-2.483c.31-.19.501-.531.501-.902v-7.661l6.76-4.107a1.055 1.055 0 00.01-1.803l-.03-.01zM30.138 36.765l-14.702-8.913v-5.548l14.171 8.322c.33.2.751.19 1.082 0l10.115-6.15v5.8l-10.656 6.5-.01-.01zm15.243-9.294l-2.484 1.513v-5.8l2.484-1.501v5.788zm.46-8.543l-3.725 2.264-11.387-7.762a1.05 1.05 0 00-1.462.28c-.331.481-.2 1.132.28 1.463l10.596 7.22-10.015 6.09-22.013-12.92 22.023-13.28 21.532 13.1-5.819 3.546h-.01z","fill":"currentColor"}})])
          )
        }
      }
    